export const FETCH_ALERT_SETTINGS = "FETCH_ALERT_SETTINGS";
export const UPDATE_ALERT_SETTINGS = "UPDATE_ALERT_SETTINGS";
export const GET_SETTINGS = "GET_SETTINGS";
export const UPDATE_SETTINGS = "UPDATE_SETTINGS";
